module.exports = __webpack_public_path__ + "img/innova-startup-week-2023 copia.06e4f386.png";